module.exports = __webpack_public_path__ + "static/media/serving-img.855364e4.jpg";